import { useEffect } from 'react'
import { useListLayoutContext } from 'pages/chatbot/layout/ListLayout/context'
import { CallingUI } from './ui/CallingUI'
import { CallingContext } from './context'

export const Calling = () => {
  const { callingStore } = useListLayoutContext()
  useEffect(callingStore.init, [])
  return (
    <CallingContext.Provider value={callingStore}>
      <CallingUI />
    </CallingContext.Provider>
  )
}
